import axios from "utils/axios";
import { canAccessAdminPanel, normalizeAuthUser } from "utils/adminAccess";
import { authService } from "services/authService";

export function mergeUserWithProfessionalProfile(
  baseUser,
  personalData = {},
  professionalData = {},
) {
  const normalized = normalizeAuthUser(baseUser) || {};
  return {
    ...normalized,
    ...personalData,
    profession_id: professionalData?.profession?.id ?? null,
    profession_name: professionalData?.profession?.name ?? null,
    specialties: professionalData?.specialties ?? [],
    work_environment: professionalData?.work_environment ?? null,
    date_of_exercise_start: professionalData?.date_of_exercise_start ?? null,
    followed_institutions: professionalData?.followed_institutions ?? [],
    years_of_experience: professionalData?.years_of_experience ?? null,
  };
}

/**
 * Fetch personal + professional info and merge into auth user.
 * Skipped for admin/sub-admin panel accounts (minimal auth only).
 */
export async function refreshSessionUserProfile(baseUser) {
  const normalized = normalizeAuthUser(baseUser);
  if (!normalized) return null;

  if (canAccessAdminPanel(normalized)) {
    return normalized;
  }

  try {
    const [personalResponse, professionalResponse] = await Promise.all([
      axios.get("/api/users/personal-info/"),
      axios.get("/api/users/professional-info/"),
    ]);
    return mergeUserWithProfessionalProfile(
      baseUser,
      personalResponse.data,
      professionalResponse.data,
    );
  } catch {
    await authService.logout();
    return null;
  }
}
